var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_2896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6125 0C11.4487 0 11.2916 0.0650918 11.1758 0.18092L9.36419 1.99246L15.738 8.36628L17.5496 6.55475C17.7908 6.31353 17.7908 5.92245 17.5496 5.68124L12.0493 0.18092C11.9335 0.0650918 11.7764 0 11.6125 0ZM13.9961 8.37207L9.359 3.73498L3.73429 9.35968L8.37139 13.9968L13.9961 8.37207ZM20.4506 17.7937L13.3859 10.729L10.7288 13.386L17.7936 20.4508C18.1598 20.8171 18.641 21.0002 19.1221 21.0002C19.6032 21.0002 20.0843 20.8171 20.4506 20.4508C21.1831 19.7182 21.1831 18.5263 20.4506 17.7937ZM0.181862 11.1758L1.99336 9.36426L8.36719 15.7381L6.55561 17.5497C6.43498 17.6703 6.27691 17.7305 6.11887 17.7305C5.96084 17.7305 5.80273 17.6702 5.68214 17.5496L0.181862 12.0493C-0.059351 11.8081 -0.059351 11.417 0.181862 11.1758Z",
    fill: "url(#paint0_linear_289_2896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6125 0C11.4487 0 11.2916 0.0650918 11.1758 0.18092L9.36419 1.99246L15.738 8.36628L17.5496 6.55475C17.7908 6.31353 17.7908 5.92245 17.5496 5.68124L12.0493 0.18092C11.9335 0.0650918 11.7764 0 11.6125 0ZM13.9961 8.37207L9.359 3.73498L3.73429 9.35968L8.37139 13.9968L13.9961 8.37207ZM20.4506 17.7937L13.3859 10.729L10.7288 13.386L17.7936 20.4508C18.1598 20.8171 18.641 21.0002 19.1221 21.0002C19.6032 21.0002 20.0843 20.8171 20.4506 20.4508C21.1831 19.7182 21.1831 18.5263 20.4506 17.7937ZM0.181862 11.1758L1.99336 9.36426L8.36719 15.7381L6.55561 17.5497C6.43498 17.6703 6.27691 17.7305 6.11887 17.7305C5.96084 17.7305 5.80273 17.6702 5.68214 17.5496L0.181862 12.0493C-0.059351 11.8081 -0.059351 11.417 0.181862 11.1758Z",
    fill: "url(#paint1_linear_289_2896)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_2896",
    x1: 0,
    y1: -100,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF800B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_2896",
    x1: 13.6026,
    y1: -3.25304,
    x2: 13.5462,
    y2: 8.36628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_2896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 21 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.e20c90a145b6856903f75a0ed1b79e3c.svg";
export { ForwardRef as ReactComponent };